export default () => {

    const button = document.querySelector('.js-toggle-nav')
    const mobileNav = document.querySelector('.js-mobile-nav')
    const mobileNavLink = document.querySelectorAll('.c-mobile-nav__link')
    const mobileChild = document.querySelectorAll('.js-mobile-child')

    if (button) {
        button.addEventListener('click', e => {
            document.body.classList.toggle('menu-open')
            document.documentElement.classList.toggle('menu-open') //html
            mobileNav.classList.toggle('c-mobile-nav--active')
        })
        ;[...mobileNavLink].forEach(mobileNavLinkSingle => {
            mobileNavLinkSingle.addEventListener('click', evt => {
                console.log('click')
                if (document.querySelector('body').classList.contains('menu-open') && document.documentElement.classList.contains('menu-open')) {
                    document.body.classList.remove('menu-open')
                    document.documentElement.classList.remove('menu-open')
                    mobileNav.classList.remove('c-mobile-nav--active')
                }
            })
        })

    }

    if (mobileChild.length) {
        ;[...mobileChild].forEach(child => {
            const target = child.querySelector('.js-mobile-child-container')
            child.addEventListener('click', e => {
                target.classList.toggle('c-mobile-nav__child-container--active')
                child.classList.toggle('c-mobile-nav__link--active')
            })
        })
    }

}

// WEBPACK FOOTER //
// ./src/js/modules/MobileHeader.js
